import Link from "@packages/components/ui/Link";
import { cn } from "@packages/lib/utils";
import { VariantProps } from "class-variance-authority";
import { MouseEventHandler, ReactNode } from "react";
import { buttonVariants } from "./Button";

interface LinkButtonProps {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  ariaLabel?: string;
  prefetch?: boolean;
  variant?: VariantProps<typeof buttonVariants>["variant"];
  size?: VariantProps<typeof buttonVariants>["size"];
}

export default function LinkButton({
  href,
  className,
  children,
  onClick,
  ariaLabel,
  variant = "default",
  size = "default",
  prefetch,
}: LinkButtonProps) {
  return (
    <Link
      href={href}
      className={cn(buttonVariants({ variant, size }), className)}
      prefetch={prefetch}
      onClick={onClick}
      role="button"
      aria-label={ariaLabel}
    >
      <span className="inline-flex max-w-full items-center gap-2 truncate">
        {children}
      </span>
    </Link>
  );
}
